import { ApiError } from "@/pages/auth/api";
import { API_BASE_URL } from "@/shared/config/apiBaseUrl";

import type {
  LivestreamActivitySummary,
  LivestreamGuessResult,
  LivestreamSnapshot,
  SubmitLivestreamGuessPayload,
} from "./types";

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let detail = `request failed with status ${response.status}`;
    try {
      const payload = (await response.json()) as { detail?: string };
      if (payload.detail) {
        detail = payload.detail;
      }
    } catch {
      // Keep fallback message when the response is not JSON.
    }
    throw new ApiError(detail, response.status);
  }

  return (await response.json()) as T;
}

export async function getCurrentLivestream(): Promise<LivestreamSnapshot> {
  const response = await fetch(`${API_BASE_URL}/api/livestream/current`);
  return parseJson<LivestreamSnapshot>(response);
}

export async function getLivestreamMe(sessionToken: string): Promise<LivestreamActivitySummary> {
  const response = await fetch(`${API_BASE_URL}/api/livestream/me`, {
    headers: {
      Authorization: `Bearer ${sessionToken}`,
    },
  });
  return parseJson<LivestreamActivitySummary>(response);
}

export async function submitLivestreamGuess(
  sessionToken: string,
  cursorToken: string,
  payload: SubmitLivestreamGuessPayload,
): Promise<LivestreamGuessResult> {
  const response = await fetch(`${API_BASE_URL}/api/livestream/guesses`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify({
      cursor_token: cursorToken,
      guess_move: payload.guess_move,
      submission_mode: payload.submission_mode,
    }),
  });

  return parseJson<LivestreamGuessResult>(response);
}

